import api from '@/components/mixins/baseApi';

/**
 * Статус участника — запись.
 *
 * Договорённость с бэком описана в docs/participant-status-api.md:
 * `PUT /profile/status` с телом `{ status: <код> }`, ответ —
 * `{ results: { status: <код> } }`. Снятие статуса — тем же запросом с `null`.
 *
 * Чтения тут нет: статус приходит полем `status` в уже существующих ответах
 * `GET /profile` и `GET /participant/{id}`. Отдельный запрос на каждую карточку
 * был бы лишним кругом по сети.
 *
 * Заглушки и флага готовности тоже нет: бэкенд появился на стенде раньше, чем
 * взялись за клиентскую часть, — хранить статус в браузере не понадобилось.
 */
export default {
  mixins: [api],

  methods: {
    /**
     * Ставит или снимает статус. Промис завершается кодом, который в итоге
     * стоит на сервере; при неудаче — отказом, чтобы экран вернул прежний.
     *
     * Успехом считается только совпадение ответа с отправленным, а не сам факт
     * `resolve`. На `401` и `403` общий обработчик в `baseApi.js` намеренно
     * отдаёт успешный промис с подставным телом `{ results: { message } }` —
     * переход на экран входа уже сделан, показывать ошибку некому. Но для
     * записи это неотличимо от удачи, и без сверки экран нарисовал бы статус
     * сохранённым, уезжая на вход.
     *
     * Тело ошибки не разбираем: сервер отдаёт на неё голый текст без обёртки
     * `results`. Смысл несёт только код ответа.
     */
    setMyStatus(code) {
      return this.baseAxios({
        method: 'put',
        url: `${this.$store.getters.apiBasePath}/profile/status`,
        data: { status: code },
      })
        .then((data) => {
          if (!data || !data.results || data.results.status !== code) {
            return Promise.reject(new Error('status was not saved'));
          }
          return data.results.status;
        });
    },
  },
};
